import { Typography, Separator, Button } from '@ui/components';
import { OnboardingInfoDto } from '@interfaces/models';
import { Success } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { useState, FC } from 'react';
import { cn } from '@ui/utils';

import { SkipOnboardingDialog } from './skip-onboarding/skip-onboarding';
import { useOnboardingStepper } from './use-onboarding-stepper';

export const OnboardingStepper: FC<OnboardingInfoDto> = ({ mode, hasSubscriptionsAssigned }) => {
  const [isSkipOnboardingDialogOpen, setIsSkipOnboardingDialogOpen] = useState(false);
  const { routesInOrder } = useOnboardingStepper({ mode, hasSubscriptionsAssigned });

  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h300" element="h2">
        {t('ONBOARDING.STEPS.STEPS')}
      </Typography>

      <ul className="mt-8 space-y-6 list-none">
        {routesInOrder.map((route) => (
          <Typography
            className={cn('text-disabled w-full inline-flex justify-between items-center', {
              'text-surface': route.active,
              'text-weak': route.completed,
            })}
            key={route.key}
            variant="h200"
            element="li"
          >
            <span>
              {!route.isChild && <span className="mr-4">{route.idx}</span>}
              <span className={cn(route.isChild && 'ml-10')}>
                {t(`ONBOARDING.STEPS.${route.key}`)}
              </span>
            </span>
            {route.completed && <Success className="size-4" />}
          </Typography>
        ))}
      </ul>

      <Separator className="my-6" />

      <Button
        className="whitespace-normal text-center min-h-10 h-full py-2"
        onClick={() => setIsSkipOnboardingDialogOpen(true)}
        variant="tertiary"
        wide
      >
        {t('ONBOARDING.SKIP')}
      </Button>

      <SkipOnboardingDialog
        onOpenChange={setIsSkipOnboardingDialogOpen}
        open={isSkipOnboardingDialogOpen}
      />
    </>
  );
};
